import {MyDeviceRequestContainerModel} from './my-device-request-container.model';
import {MyNotDeviceRequestContainerModel} from './my-not-device-request-container.model';
import {ProductModel} from './product.model';
import {ProjectModel} from './project.model';
import {MyOfferTextModuleContainerModel} from './my-offer-text-module-container.model';
import {ContactModel} from './brother-contacts.model';
import {PriceApprovalStatusEnum} from '../enums/price-approval-status.enum';
import {SupplyAcquisitionTypeEnum} from '../enums/supply-acquisition-type.enum';

export class MyDialogDataModel {

    // public isProjectSubmitValidationVisibilityForced: boolean;
    public isFirstStepSaveValidationVisibilityForced: boolean;
    public isProjectNameSaveValidationVisibilityForced: boolean;
    public isStep3ButtonsValidationVisibilityForced: boolean;
    public isStep4ButtonsValidationVisibilityForced: boolean;


    // data fields
    public project: ProjectModel;

    public projectRepository: ProjectModel;

    public products: ProductModel[];


    // onRPricesBasedApprovalStatusDetailsHelper is used to calculate approvalStatusDetails === PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED which is based only on rPrices status,
    // so approvalStatusDetails === PriceApprovalStatusEnum.PRICE_APPROVAL_REQUESTED means something like that somme device has R8 price or some supply has R6 price
    // see editModalService.updateRPricesBasedApprovalStatusDetailsHelper method for detail condition/rules
    public onRPricesBasedApprovalStatusDetailsHelper: PriceApprovalStatusEnum;


    public isDeviceOrderRequested = true;
    public isAccessoryOrderRequested = true;
    public isWarrantyOrderRequested = true;
    public isServiceOrderRequested = true;
    public isUpgradesOrderRequested = true;


    public isServiceDescriptionActive = false;

    // containers
    // availableContainers contains all offered products, warranties etc.
    // requestedContainers contains items from availableContainers which were selected by user

    // ========= 3.dialog step ===========
    // used for sub-dialog on 3.dialog step to allow select product to show in 3.step main dialog
    public availableDevicesContainers: MyDeviceRequestContainerModel[];  // all device and noDevices which has deviceParent categorised
    // used for table of selected/requested products on 3.step on main dialog
    public requestedDevicesContainers: MyDeviceRequestContainerModel[];


    // ========= 4.dialog step ===========
    public availableAccessoryContainers: MyNotDeviceRequestContainerModel[];    // all accessories with and without parents/devices
    public availableWarrantyContainers: MyNotDeviceRequestContainerModel[];     // all warranties with and without parents/devices

    public noParentAccessoryContainersIndex: MyNotDeviceRequestContainerModel[];  // accessories without parents which points to availableAccessoryContainers arr
    public noParentWarrantyContainersIndex: MyNotDeviceRequestContainerModel[];     // warranties without parents points to availableWarrantyContainers arr

    // newly added to handle Warranties and Accessories separately
    public requestedWarrantyContainers: MyNotDeviceRequestContainerModel[]; // pointers to availableWarrantyContainers for thous which are selected
    public requestedAccessoryContainers: MyNotDeviceRequestContainerModel[];


    public availableUpgradesContainers: MyNotDeviceRequestContainerModel[];
    public requestedUpgradesContainers: MyNotDeviceRequestContainerModel[];

    public noParentUpgradesContainersIndex: MyNotDeviceRequestContainerModel[];

    // ========= 5.dialog steps  ===========
    //     >>>>>>>>>> 5.dialog step - (kaufen) ===========
    // used on 5.step (supplies) "right Kaufen" table  for  the sub-dialog select supply  (add-supply-categorised-modal)
    // array of devices which has some supplies connected with, and devices are selected for order on 3.page
    // it allow to list devices in select supply dialog and the use can selected supplies dedicated for this devices
    public availablePreselectedGeneralDevicesWithSupplyContainers: MyDeviceRequestContainerModel[];

    // used on 5.step (supplies) "right Kaufen" table  for  (add-supply-categorised-modal) to list all available supplies in bottom "Alle Verbrauchsmaterialien" category
    public availableSuppliesContainers: MyNotDeviceRequestContainerModel[];


    // used on 5.step (supplies) , this is content of "right Kaufen" table (app-general-supplies-shopping-table)
    public requestedPreselectedGeneralDevicesWithSupplyContainers: MyDeviceRequestContainerModel[];
    // used on 5.step (supplies) , this is content of "right Kaufen" table (app-general-supplies-shopping-table)
    // (there are two parts, this one is bottom dedicated to supply not connected to particular device)
    public requestedGeneralNoCategorisedSupplyContainers: MyNotDeviceRequestContainerModel[];

    //     >>>>>>>>>> 5.dialog step - (both printSmart modes) ===========
    // pre-filtered array of PrSmSuContainers ( only printSmart Devices ) to chose from on 5.step left tab table
    // filtered only printSmart devices with MPS supplies already selected/requested on dialog 3.step
    // note: we have two kind of supplies, supplies and MPSSupplies (printSmart dedicated supplies), this arr contains all preselected devices (on step 3 ) which contains MPS Supplies
    public availablePreselectedPrintSmartDevicesWithSupplyContainers: MyDeviceRequestContainerModel[];


    // ========= 6.dialog step - (overview) ===========
    // used to list pre-selected devices on dialog 6.page (app-supply-option-table)
    // once upon the time the content was possible to change by user, but now some MPS supply must be ordered
    // and so is probably the same like availablePreselectedPrintSmartDevicesWithSupplyContainers which the content is based on
    public requestedPreselectedPrintSmartDevicesWithSupplyContainers: MyDeviceRequestContainerModel[];

    // ==================== end of product containers


    // offerTextModulesContainers helps register if the "section" is opened/ checked
    public offerTextModulesHardwareContainers: MyOfferTextModuleContainerModel[];
    public offerTextModulesSupplyContainers: MyOfferTextModuleContainerModel[];


    // there is new request to hide brotherCustomProducts from add-products-nr-to-order-modal only, for that we need some arrays for dedicated only for this dialog
    // all products should be still available for all other lists and functionality, so the original arrays should not be changed
    // https://minntgmbh.atlassian.net/browse/BROT-1686

    public availableDevicesContainersNoCustomProducts: MyDeviceRequestContainerModel[];
    public availableWarrantyContainersNoCustomProducts: MyNotDeviceRequestContainerModel[];
    public availableAccessoryContainersNoCustomProducts: MyNotDeviceRequestContainerModel[];
    public noParentWarrantyContainersIndexNoCustomProducts: MyNotDeviceRequestContainerModel[];
    public noParentAccessoryContainersIndexNoCustomProducts: MyNotDeviceRequestContainerModel[];


    // someItemContainerIsActive indicate if aider some device or some supplies table has some content
    // we need dialog validation , because without any ordered item the request/project cannot be sent to process
    public someItemContainerIsActive = 0;
    public someDeviceTableContainerIsActive = 0;
    public someAccessoryTableContainerIsActive = 0;
    public someWarrantyTableContainerIsActive = 0;
    // public someServicesTableContainerIsActive = 0;
    public someUpgradesTableContainerIsActive = 0;

    public supplyDistributors: ContactModel[];
    public filteredSupplyDistributors: ContactModel[];
    public productDistributors: ContactModel[];
    public filteredProductDistributors: ContactModel[];

    public currentSupplyDistributor: ContactModel;
    public currentSecondarySupplyDistributor: ContactModel;
    public currentProductDistributor: ContactModel;
    public currentSecondaryDistributor: ContactModel;


    /**
     *  returns true if Project contains requested devices
     */
    public containsSomeRequestedDevicesContainers(): boolean {
        return this.isDeviceOrderRequested && this.requestedDevicesContainers?.length > 0;
    }

    // ======================== compound controls ===========


    public containsSomeStep3Containers(): boolean {
        return this.containsSomeRequestedDevicesContainers();
    }

    /**
     *  returns true if Project contains requested accessories , warranties, Upgrades
     */
    public containsSome4StepContainers(): boolean {

        let containersContainsSomeProducts: boolean = this.isAccessoryOrderRequested &&  this.requestedAccessoryContainers?.length > 0;
        containersContainsSomeProducts = containersContainsSomeProducts || this.isWarrantyOrderRequested && this.requestedWarrantyContainers?.length > 0;
        containersContainsSomeProducts = containersContainsSomeProducts || this.isUpgradesOrderRequested &&  this.requestedUpgradesContainers?.length > 0;

        return containersContainsSomeProducts;
    }

    public containsSomeStep5PurchaseContainers(): boolean {
        return SupplyAcquisitionTypeEnum[this.project && this.project.supplyAcquisitionType] === SupplyAcquisitionTypeEnum.PURCHASE &&
            !!(this.requestedPreselectedGeneralDevicesWithSupplyContainers.length ||
                this.requestedGeneralNoCategorisedSupplyContainers.length);
    }

    /**
     *  returns true if Project contains requested devices, custom devices , accessories, warranties, Upgrades
     */
    public containsSomeRequestedNotSuppliesContainers(): boolean {
        return this.containsSomeStep3Containers() || this.containsSome4StepContainers();
    }


    /**
     * return true if project contains anything to order
     */
    public containsSomeRequestedItemContainers(): boolean {
        // printSmart containers depends on 3.step containers so testing is not necessary
        return this.containsSomeStep3Containers() || this.containsSome4StepContainers() || this.containsSomeStep5PurchaseContainers();
    }

}

